/** @format */

import React, { useState, useEffect, useCallback } from "react"
import { Button } from "@ui-library/core"
import { PopinProps } from "./BuyMorePopin.types"
import { IconBuyMore, Body, StyledPopin } from "./BuyMorePopin.styled"
import { BuyMoreConfirmationPopin } from "../BuyMoreConfirmationPopin/BuyMoreConfirmationPopin"
import bffClient, {
	BuyMoreBoostsDistributionControllerRequest,
} from "_clients/BFFClient"

export const BuyMorePopin = (props: PopinProps) => {
	const [isPopinBuyMoreResponseOpen, setIsPopinBuyMoreResponseOpen] =
		useState<boolean>(false)
	const [isPopinBuyMoreOpen, setIsPopinBuyMoreOpen] = useState<boolean>(false)
	const [shouldSendEmail, setShouldSendEmail] = useState<boolean>(false)
	const [isDisabled, setIsDisabled] = useState(false)
	const { onClosePopin } = props

	const buyMoreBoosts = async (choice: boolean) => {
		setIsDisabled(true)

		const {
			consumedBoosts,
			marketId,
			productType,
			notConsumedBoosts,
			marketName,
			contractId,
		} = props.buyMoreBoostsDistribution

		const buyMoreBoostsDistribution: BuyMoreBoostsDistributionControllerRequest =
			{
				consumedBoosts,
				marketId,
				marketName,
				productType,
				notConsumedBoosts,
				contractId,
				shouldSendEmail: choice,
			}

		await bffClient.buyMoreBoosts(
			props.buyMoreBoostsDistribution.networkId,
			undefined,
			buyMoreBoostsDistribution
		)
	}

	const handleResponse = async (choice: boolean) => {
		try{
			await buyMoreBoosts(choice);
			setIsPopinBuyMoreOpen(false)
			setIsPopinBuyMoreResponseOpen(true)
			setShouldSendEmail(choice)
		}
		catch (error) {
			console.error(error);
		}
		finally {
			setIsDisabled(false)
		}
	}

	const onCloseModal = (isOpen: boolean) => {
		props.onClosePopin(isOpen)
	}

	const onCloseConfirmationPopin = useCallback(
		value => {
			setIsPopinBuyMoreResponseOpen(value)
			onCloseModal(false)
		},
		[onCloseModal]
	)
	useEffect(() => {
		setIsPopinBuyMoreOpen(props.open)
	}, [props])

	return (
		<>
			{isPopinBuyMoreOpen ? (
				<StyledPopin
					open={isPopinBuyMoreOpen}
					size="small"
					onClose={() => onCloseModal(false)}
					testID="gsl.uilib.buyMore.Popin"
				>
					<Body>
						<IconBuyMore data-testid="icon-buyMore"></IconBuyMore>

						<div className="thumbs-form">
							<div className="title">Commandez plus de boosts</div>
							<p className="text-wrapper">
								<span>
									Confirmez votre demande, nous la prenons en compte et
									reviendrons vers vous rapidement pour finaliser votre
									commande.
								</span>
							</p>
						</div>
						<div className="buttons">
							<Button
								size="large"
								testID="btn-buyMorePopin-decline"
								kind="tertiary"
								variant="normal"
								tag="button"
								disabled={isDisabled}
								onClick={() => {
									handleResponse(false)
								}}
								className="tertiary-button-border"
								onPointerEnterCapture={undefined}
								onPointerLeaveCapture={undefined}
							>
								Non merci
							</Button>
							<Button
								size="large"
								testID="btn-buyMorePopin-confirm"
								kind="primary"
								variant="normal"
								tag="button"
								disabled={isDisabled}
								onClick={() => {
									handleResponse(true)
								}}
								onPointerEnterCapture={undefined}
								onPointerLeaveCapture={undefined}
							>
								Confirmer
							</Button>
						</div>
					</Body>
				</StyledPopin>
			) : (
				<BuyMoreConfirmationPopin
					open={isPopinBuyMoreResponseOpen}
					shouldSendEmail={shouldSendEmail}
					onClosePopin={value => {
						setIsPopinBuyMoreResponseOpen(value)
						onCloseModal(false)
					}}
				></BuyMoreConfirmationPopin>
			)}
		</>
	)
}
